module.exports = "/images/vendor/desiigner-svg/svg/logos/visit_brescia.svg?c31ca34bd24b13c47130e4ba6e5be24d";